module.exports = __webpack_public_path__ + "static/img/jake-blucker-tMzCrBkM99Y-unsplash_thumb.49561a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/jake-blucker-tMzCrBkM99Y-unsplash_thumb.png
// module id = DDXt
// module chunks = 4